import { render, staticRenderFns } from "./ClubCard.vue?vue&type=template&id=5f954a39&scoped=true&lang=pug&"
import script from "./ClubCard.vue?vue&type=script&lang=js&"
export * from "./ClubCard.vue?vue&type=script&lang=js&"
import style0 from "./ClubCard.vue?vue&type=style&index=0&id=5f954a39&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f954a39",
  null
  
)

export default component.exports